<template>
  <v-container>
    <!--  标题   -->
    <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218); height: 10px;" class="ml-4 mt-2">
      设备点检异常记录
      <v-icon></v-icon>
    </p>
    <v-icon></v-icon>
    <span class="ml-4" style="color:rgb(132, 132, 132); font-size: 12px;">根据消防点检情况进行填写</span>
    <div>
      <!-- 填报表单 -->
      <v-form ref="form" v-model="isValid">
        <v-card-text>
          <v-row>

            <!-- 设备编号 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid;border-radius: 3px; height: 124px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备编号 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.abnormal_device_id" label="请输入设备编号" :rules="requiredRules" required
                hint="请输入设备编号"></v-text-field>
            </v-col>

            <!-- 设备类型 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备类型 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-select dense v-model="formData.abnormal_type" :items="deviceOptions" label="请选择设备类型"
                :rules="requiredRules" required hint="请选择设备类型"></v-select>
            </v-col>

            <!-- <v-col cols="12" style="border: 1px rgb(188,188,189) solid;border-radius: 3px; height: 124px;" class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备类型 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.abnormal_type" :items="deviceOptions" label="请输入设备类型"
                :rules="requiredRules" required hint="请输入设备类型"></v-text-field>
            </v-col> -->

            <!-- 点检反馈结果 -->
            <v-col cols="12" class="mt-1"
              style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
              <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px; padding: 0;">设备状态 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-radio-group v-model="formData.abnormal_status" label="" :rules="requiredRules" required row
                class="d-flex align-center">
                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;" label="正常"
                  value="正常"></v-radio>
                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;" label="异常"
                  value="异常"></v-radio>
              </v-radio-group>
            </v-col>

            <!-- 设备楼栋 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid;border-radius: 3px; height: 124px;" class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">位置楼宇 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.abnormal_buliding" label="请输入设备楼宇" :rules="requiredRules" required
                hint="请输入设备楼宇"></v-text-field>
            </v-col>

            <!-- 设备楼层 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid;border-radius: 3px; height: 124px;" class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备楼层 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.abnormal_floor" label="请输入设备楼层" :rules="requiredRules" required
                hint="请输入设备楼层"></v-text-field>
            </v-col>

            <!-- 设备描述 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">详情描述 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-textarea v-model="formData.abnormal_description" label="设备异常情况说明" :rules="requiredRules" required
                hint="设备异常情况说明"></v-textarea>
            </v-col>

            <!-- 上传现场图片 -->
            <v-col cols="12" sm="6" md="4" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">上传附件 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-file-input v-model="abnormal_attachment" label="上传现场图片" accept="image/*" required
                hint="支持上传图片、PDF、Word文档" @change="uploadImage(abnormal_attachment)" :rules="[v => !!v || '请上传一张图片']">
                <!-- @update:model-value="handleFileInput" -->
              </v-file-input>
              <v-img v-if="imageUrl" :src="imageUrl" aspect-ratio="1" class="mt-4" max-width=""></v-img>
            </v-col>

            <!-- 巡检人员标题 -->
            <v-col class="d-flex align-center float-left mt-4" style="height:40px;">
              <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218);">
                <v-icon style="color: rgb(50,134,218);">mdi-account-circle</v-icon>
                巡检人员信息
              </p>
            </v-col>

            <!-- 巡检人 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid;border-radius: 3px; height: 124px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">巡检人员 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.abnormal_staff" label="请输入巡检人" :rules="requiredRules" required
                hint="请输入巡检人"></v-text-field>
            </v-col>

            <!-- 巡检部门 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid;border-radius: 3px; height: 124px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">巡检部门 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.abnormal_department" label="请输入巡检部门/组" :rules="requiredRules" required
                hint="请输入巡检部门/组"></v-text-field>
            </v-col>

            <!-- 巡检时间 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid;border-radius: 3px; height: 124px;">
              <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px;">巡检时间 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.abnormal_date" label="" readonly hint="自动填充当前时间"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-around">
          <v-btn color="success" dark @click="resetForm">重置</v-btn>
          <!-- <v-spacer></v-spacer>   -->
          <v-btn color="blue darken-1" dark @click="submitForm">提交</v-btn>
        </v-card-actions>
      </v-form>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'check',
  data() {
    return {
      isValid: false,                                         // 填报表单的状态
      formData: {
        abnormal_device_id: '',                               // 设备编号（设备上的唯一编号）
        abnormal_type: '',                                    // 设备类型 
        abnormal_status: '异常',                              // 设备状态
        abnormal_buliding: '',                                // 设备楼宇
        abnormal_floor: '',                                   // 设备楼层
        abnormal_attachment: null,                            // 上传图片Url
        abnormal_description: '',                             // 设备详情描述
        abnormal_staff: '',                                   // 巡检人员
        abnormal_department: '',                              // 巡检部门
        abnormal_date: '',                                    // 巡检时间
      },
      imageUrl: null,
      deviceOptions: ['灭火器', '消防栓', '烟感设备', '手报设备', '防火卷帘', '应急设备', '排烟设备'],
      requiredRules: [v => !!v || '该字段是必填项']            // 正则判断
    }
  },
  // 初始化进入表单时读取当前系统时间进行传给表单填报时间
  mounted() {
    this.initializeTime();
  },
  methods: {
    // 格式化时间
    async initializeTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const formattedMonth = month < 10 ? '0' + month : month.toString();
      const formattedDay = day < 10 ? '0' + day : day.toString();
      const formattedHours = hours < 10 ? '0' + hours : hours.toString();
      const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
      const formattedSeconds = seconds < 10 ? '0' + seconds : seconds.toString();
      const formattedDateTime = `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      this.formData.abnormal_date = formattedDateTime;
      return formattedDateTime;
    },


    // 执行表单提交填报
    async submitForm() {
      console.log('填报的数据信息', this.formData);
      if (this.isValid) {
        try {
          await this.submitFormData();
          this.showSucceSnackbar("填报成功。");
        } catch (error) {

        }

      }
    },


    // 拼接图片和字段文本内容直接提交
    async submitFormData() {
      try {
        // const imageUrl = await this.uploadImage(this.formData.abnormal_attachment);
        const textData = {
          abnormal_device_id: this.formData.abnormal_device_id,
          abnormal_type: this.formData.abnormal_type,
          abnormal_status: this.formData.abnormal_status,
          abnormal_description: this.formData.abnormal_description,
          abnormal_buliding: this.formData.abnormal_buliding,
          abnormal_floor: this.formData.abnormal_floor,
          abnormal_staff: this.formData.abnormal_staff,
          abnormal_department: this.formData.abnormal_department,
          abnormal_date: this.formData.abnormal_date,
          abnormal_attachment: this.imageUrl,
        };
        console.log('拼接表单字段内容', textData);
        const jsonData = JSON.stringify(textData);

        console.log(jsonData);
        const response = await fetch('http://192.168.3.3:18081/abnormal/addAbnormal', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: jsonData,
        });
        if (!response.ok) {
          throw new Error("提交失败!");
        }
        console.log("提交成功!");
        this.$router.push("/logoCheck");


      } catch (error) {
        console.error('提交过程中发生错误：', error);
        this.showErrorSnackbar('提交失败，请检查网络或数据格式');
      }
    },


    // 上传图片
    async uploadImage(abnormal_attachment) {
      const formData = new FormData();
      const file = abnormal_attachment;
      console.log("上传图片获取的地址", file)
      if (file) {
        formData.append('abnormal_attachment', file);
      }
      try {
        const response = await fetch('http://192.168.3.3:18081/abnormal/files/upload/image', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          throw new Error('图片上传失败!');
        }

        const data = await response.json();
        console.log('data', data);
        const userData = data.data;
        console.log('userfile', userData);
        this.imageUrl = userData;

        // 进行服务器保存图片进行回调的结果集合
        // this.imageUrl = data.data;
        console.log("图片上传成功,地址:", this.imageUrl);
        return this.imageUrl;
      } catch (error) {
        console.error("图片上传失败!", error);
        throw error;
      }
    },


    // 上传表单文本
    // async submiTextData(textData) {
    //   const jsonData = JSON.stringify(textData);
    //   console.log(jsonData);
    //   const response = await fetch('http://127.0.0.1:18080/abnormal/addAbnormal', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: jsonData,
    //   });
    //   console.log(response);
    //   // return response;
    // },

    // 重置表单数据逻辑
    async resetForm() {
      const currentTime = await this.initializeTime();
      this.formData = {
        abnormal_device_id: '',
        abnormal_type: '',
        abnormal_status: '异常',
        abnormal_buliding: '',
        abnormal_floor: '',
        abnormal_description: '',
        abnormal_attachment: null,
        abnormal_staff: '',
        abnormal_department: '',
        abnormal_date: currentTime,
      },
        this.imageUrl = null;
    },
    // 设备异常显示当前界面
    showErrorSnackbar(message) {
      this.$snackbar = {
        isShowing: true,
        message: message,
        coSlor: 'error',
        timeout: 5000
      }
    },
    // 保存页面上传的图片
    // handleFileInput(file) {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //       this.imageUrl = e.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   } else {
    //     this.imageUrl = null;
    //   }
    // }
  }
}  
</script>